/** Bulk transfer in (PHP-3941): reading "domain, auth code" pairs pasted one per line or from a two-column CSV. */

export const MAX_BULK_TRANSFERS = 100;

export interface TransferPair {
  fqdn: string;
  auth_code: string;
}

/** One CSV line split into cells: commas separate, double quotes may wrap a cell (`""` is a quote inside one). */
function cells(line: string): string[] {
  const out: string[] = [];
  let cell = "";
  let quoted = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (quoted) {
      if (ch === '"' && line[i + 1] === '"') {
        cell += '"';
        i++;
      } else if (ch === '"') quoted = false;
      else cell += ch;
    } else if (ch === '"' && cell.trim() === "") {
      quoted = true;
      cell = "";
    } else if (ch === "," || ch === "\t" || ch === ";") {
      out.push(cell);
      cell = "";
    } else cell += ch;
  }
  out.push(cell);
  return out.map((c) => c.trim());
}

/**
 * The pairs in pasted text or a CSV file: one per line, the domain then its code. Blank lines are skipped, and so is
 * a first line that is a header (`domain, auth code`). The code is everything after the first separator, so a code
 * with a comma in it survives when it is quoted.
 */
export function parseTransferPairs(text: string): TransferPair[] {
  const lines = text.split(/\r?\n/).filter((l) => l.trim() !== "");
  const pairs = lines.map((line) => {
    const [fqdn = "", ...rest] = cells(line);
    return { fqdn: fqdn.toLowerCase(), auth_code: rest.filter(Boolean).join(",") };
  });
  if (/^(domain|domain ?name|fqdn|name)$/i.test(pairs[0]?.fqdn ?? "")) pairs.shift();
  return pairs;
}
